import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class ServiceDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

        return	<section className="service-details">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 clearfix">
                        <img src={publicUrl+"assets/images/resources/scalable-business.jpg"} alt={ imagealt } className="float-right wow fadeInLeft" data-wow-duration="1500ms" />
                    </div>{/* /.col-lg-6 */}
                    <div className="col-lg-6">
                        <div className="service-details__content">
                            <h3>Scalable Business Performance</h3>
                            <p>Converzex.ai is built to grow with your business, delivering reliable performance across increasing customer interactions, multiple communication channels, and expanding operations. Whether you're handling hundreds or thousands of conversations daily, our AI-powered platform maintains speed, accuracy, and stability without compromising user experience.</p>
                            <p>From websites and WhatsApp to voice calls and CRM integrations, the system seamlessly manages multi-channel engagement while keeping all customer data centralized and organized. With scalable cloud infrastructure and intelligent automation, Converzex.ai empowers businesses to expand efficiently, reduce operational workload, and support long-term growth with confidence.</p>

                        </div>{/* /.service-details__content */}
                    </div>{/* /.col-lg-6 */}
                </div>{/* /.row */}

            </div>{/* /.container */}
        </section>

    }
}

export default ServiceDetails